import {
    ADD_NEWMERCHANT_FAILED,
    ADD_NEWMERCHANT_LOADING,
    ADD_NEWMERCHANT_SUCCESS,
} from "../types";

const initialState = {
    loading: false,
    error: null,
    status: null,
};

export const addNewMerchantReducer = (
    state = initialState,
    action: { type: any; loading: any; payload: any; status: any; error: any }
) => {

    switch (action.type) {
        case ADD_NEWMERCHANT_LOADING:
            return {
                ...state,
                loading: action.loading,
            };
        case ADD_NEWMERCHANT_SUCCESS:
            return {
                ...state,
                loading: false,
                MerchantPayment: action.payload,
                status: action.status,
                error: null,
            };
        case ADD_NEWMERCHANT_FAILED:
            return {
                ...state,
                loading: false,
                status: action.status,
                error: action.error,
            };
       
        default:
            return state;
    }
};




